import {
  DatePicker,
  Button,
  Form,
  Input,
  Select,
  Table,
  Modal,
  Switch,
  Popover,
} from "antd";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import _debounce from "lodash/debounce";
import { CiCirclePlus } from "react-icons/ci";
import {
  columnsData,
  columnsDataAssign,
  columnsDataAssign2,
  columnsDataHistoryParticipant,
  columnsDataHistoryStatus,
  columnsDataHistorySupporter,
  columnsDataMobile,
  columnsDataModal,
  columnsText,
  dataText,
} from "./data";
import {
  notifyError,
  notifySuccess,
  notifyWarning,
} from "../../../components/notification";
import { CSS } from "@dnd-kit/utilities";
import { api } from "../../../services/api/api.index";
import { RiDeleteBin2Line } from "react-icons/ri";
import { API_URL, API_URL_BOOK } from "../../../services/api/config";
import {
  AiOutlineSearch,
  AiOutlineReload,
  AiFillCheckCircle,
} from "react-icons/ai";
import { BiSave, BiSolidErrorCircle } from "react-icons/bi";
import moment, { isMoment } from "moment";
import {
  localGetMenu,
  localGetRefreshToken,
  localRemoveMenu,
  localRemoveRefreshToken,
  localRemoveToken,
  localSaveRefreshToken,
  localSaveToken,
} from "../../../utils/localStorage";
import { useNavigate } from "react-router-dom";
import OverlaySpinner from "../../../components/overlaySpinner/OverlaySpinner";
import axios from "axios";
import PanigationAntStyled from "../../../components/layout/PanigationAntStyled";
import { UserContext } from "../../../context/context";
import { exportExcel } from "../../../utils/helpers/functions/textUtils";
import SvgExcel from "../../../assets/svg/SvgExcel";
import SvgFile from "../../../assets/svg/SvgFile";
import { FiPlusCircle } from "react-icons/fi";
import { Editor } from "@tinymce/tinymce-react";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { DndContext } from "@dnd-kit/core";
const { RangePicker } = DatePicker;
const GoldenBooks = () => {
  const [dataSource, setDataSource] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [dataDes, setDataDes] = useState("");
  const [selectedClient, setSelectedClient] = useState([]);
  const [form] = Form.useForm();
  const [formUpdate] = Form.useForm();
  const [formCreate] = Form.useForm();
  const [imagesCreate, setImagesCreate] = useState([]);
  const [imagesUpdate, setImagesUpdate] = useState([]);

  const [total, setTotal] = useState(0);
  const [dataDetails, setDataDetails] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const editorRef = useRef(null);
  const [filter, setFilter] = useState({
    q: undefined,
    status: undefined,
    page: 1,
    limit: 10,
  });
  const [refresh, setRefresh] = useState(false);
  const { state, dispatch } = useContext(UserContext);

  const getData = async () => {
    setLoading(true);

    try {
      let data = await api.get(`${API_URL}api/v1/golden-books`, {
        ...filter,
      });
      setDataSource(data?.data);
      setTotal(data?.metadata?.totalItems);
      setLoading(false);
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          getData();
        } catch (e) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  const uploadFileHandlerCreate = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    try {
      const { data } = await api.postMultipart(`${API_URL}api/v1/uploads`, {
        files: file,
      });
      let fakeImages = [...imagesCreate];
      fakeImages.push(data[0]);
      console.log(fakeImages);
      setImagesCreate(fakeImages);
      setLoading(false);
      document.getElementById("imageFileCreate").value = "";
      // setImage(data);
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          handleFinishFormUpdate(e);
        } catch (error) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  const uploadFileHandlerUpdate = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    try {
      const { data } = await api.postMultipart(`${API_URL}api/v1/uploads`, {
        files: file,
      });
      let fakeImages = [...imagesUpdate];
      fakeImages.push(data[0]);
      console.log(fakeImages);
      setImagesUpdate(fakeImages);
      setLoading(false);
      document.getElementById("imageFileUpdate").value = "";
      // setImage(data);
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          handleFinishFormUpdate(e);
        } catch (error) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };
  const getDataById = async (id) => {
    setLoading(true);

    try {
      let { data } = await api.get(`${API_URL}api/v1/golden-books/${id}`, {});
      setDataDetails(data);

      let arrayItems = data?.form?.items?.slice(13);
      for (let i = 0; i < arrayItems.length; i++) {
        if (arrayItems[i]?.code?.toLowerCase()) {
          formUpdate.setFieldsValue({
            [arrayItems[i]?.code?.toLowerCase()]:
              data?.[arrayItems[i]?.code?.toLowerCase()],
          });
        }
      }
      formUpdate.setFieldsValue({
        trade_account_for_contest: data?.trade_account_for_contest,
        passview: data?.passview,
        trade_app: data?.trade_app,
        trade_server: data?.trade_server,
        target_usd: data?.target_usd,
        supporter_note: data?.supporter_note,
      });
      setLoading(false);
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          getDataById(id);
        } catch (e) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  const handleFinishForm = (e) => {
    setFilter({
      ...filter,
      page: 1,
      q: e?.q?.length > 0 ? e?.q?.trim() : undefined,

      status: e?.status,
    });
  };

  const handleFinishFormCreate = async (e) => {
    setLoading(true);
    try {
      let { data } = await api.post(`${API_URL}api/v1/golden-books`, {
        ...e,
        images: imagesCreate,
        description: editorRef.current.getContent(),
      });

      notifySuccess("Tạo thành công!");
      setLoading(false);
      setOpenModalCreate(false);
      formCreate.resetFields();
      setImagesCreate([]);
      getData();
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          handleFinishFormUpdate(e);
        } catch (error) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  const handleChangeStatus = async (value, record) => {
    setLoading(true);
    try {
      let { data } = await api.put(
        `${API_URL}api/v1/golden-books/${record.id}`,
        {
          status: value ? "ACTIVE" : "INACTIVE",
          email: record?.email,
          images: record?.images,
        }
      );
      let newList = [...dataSource].map((x) =>
        x.id === record.id ? { ...x, status: value ? "ACTIVE" : "INACTIVE" } : x
      );
      setDataSource(newList);
      notifySuccess("Đổi trạng thái thành công!");
      setLoading(false);
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          handleChangeStatus(value, record);
        } catch (error) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  const handleFinishFormUpdate = async (e) => {
    setLoading(true);
    try {
      let { data } = await api.put(
        `${API_URL}api/v1/golden-books/${dataDetails?.id}`,
        {
          ...e,
          images: imagesUpdate,
          description: editorRef.current.getContent(),
        }
      );
      setImagesUpdate([]);
      notifySuccess("Cập nhật thông tin thành công!");
      setDataDetails(undefined);
      setOpenModal(false);
      setLoading(false);
      getData();
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          handleFinishFormUpdate(e);
        } catch (error) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };
  const handleSort = (value) => {
    let fake = { ...filter };
    if (value === 1) {
      setFilter({
        ...filter,
        sort_by: "name",
        sort_type:
          fake?.sort_by === "name"
            ? fake?.sort_type === "ASC"
              ? "DESC"
              : "ASC"
            : "ASC",
      });
    }
    if (value === 2) {
      setFilter({
        ...filter,
        sort_by: "email",
        sort_type:
          fake?.sort_by === "email"
            ? fake?.sort_type === "ASC"
              ? "DESC"
              : "ASC"
            : "ASC",
      });
    }
    if (value === 3) {
      setFilter({
        ...filter,
        sort_by: "form_info",
        sort_type:
          fake?.sort_by === "form_info"
            ? fake?.sort_type === "ASC"
              ? "DESC"
              : "ASC"
            : "ASC",
      });
    }
    if (value === 4) {
      setFilter({
        ...filter,
        sort_by: "created_at",
        sort_type:
          fake?.sort_by === "created_at"
            ? fake?.sort_type === "ASC"
              ? "DESC"
              : "ASC"
            : "ASC",
      });
    }
    if (value === 5) {
      setFilter({
        ...filter,
        sort_by: "status",
        sort_type:
          fake?.sort_by === "status"
            ? fake?.sort_type === "ASC"
              ? "DESC"
              : "ASC"
            : "ASC",
      });
    }
    if (value === 6) {
      setFilter({
        ...filter,
        sort_by: "supporter_info",
        sort_type:
          fake?.sort_by === "supporter_info"
            ? fake?.sort_type === "ASC"
              ? "DESC"
              : "ASC"
            : "ASC",
      });
    }
    if (value === 8) {
      setFilter({
        ...filter,
        sort_by: "exported_at",
        sort_type:
          fake?.sort_by === "exported_at"
            ? fake?.sort_type === "ASC"
              ? "DESC"
              : "ASC"
            : "ASC",
      });
    }
    if (value === 9) {
      setFilter({
        ...filter,
        sort_by: "total_reward_usd",
        sort_type:
          fake?.sort_by === "total_reward_usd"
            ? fake?.sort_type === "ASC"
              ? "DESC"
              : "ASC"
            : "ASC",
      });
    }

    if (value === 10) {
      setFilter({
        ...filter,
        sort_by: "updated_at",
        sort_type:
          fake?.sort_by === "updated_at"
            ? fake?.sort_type === "ASC"
              ? "DESC"
              : "ASC"
            : "ASC",
      });
    }
  };

  const onChangePaging = (page, pageSize) => {
    setFilter({
      ...filter,

      page: page,
      limit: pageSize,
    });
    setSelectedClient([]);
  };

  const handleOpenModal = (record, type) => {
    setOpenModal(true);
    formUpdate.setFieldsValue({
      email: record?.email,
      gender: record?.gender,
      name: record?.name,

      passview: record?.passview,

      phone: record?.phone,

      telegram_username: record?.telegram_username,
      trade_account: record?.trade_account,
      trade_server: record?.trade_server,

      zalo_name: record?.zalo_name,
      zalo_phone: record?.zalo_phone,
      description: record?.description,
    });
    setImagesUpdate(record?.images);
    setDataDes(record?.description);
    setDataDetails({
      email: record?.email,
      gender: record?.gender,
      name: record?.name,
      id: record?.id,
      passview: record?.passview,

      phone: record?.phone,

      telegram_username: record?.telegram_username,
      trade_account: record?.trade_account,
      trade_server: record?.trade_server,

      zalo_name: record?.zalo_name,
      zalo_phone: record?.zalo_phone,
      description: record?.description,
    });
  };

  const rowSelection = {
    selectedRowKeys: selectedClient,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedClient(selectedRowKeys);
    },
  };

  const [pageMenu, setPageMenu] = useState({
    list: false,
    details: false,
    create: false,
    update: false,
    assign: false,
    sync: false,
    import: false,
    export: false,
  });
  useEffect(() => {
    let localMenu = JSON.parse(localGetMenu());
    let fakePageMenu = { ...pageMenu };
    let fakeNewMenu = localMenu || [];
    let checkAll = fakeNewMenu.find((x) => x?.fe_route === "/golden-books");
    if (!checkAll) {
      navigate("/");
    } else {
      let checkView = checkAll?.permissions?.find(
        (y) => y?.permission === "VIEW_LIST"
      );
      if (checkView?.status === "INACTIVE") {
        navigate("/");
      } else {
        fakePageMenu = { ...fakePageMenu, list: true };
      }

      fakePageMenu = {
        ...fakePageMenu,
        create:
          checkAll?.permissions?.find((y) => y?.permission === "CREATE")
            ?.status === "ACTIVE"
            ? true
            : false,
        update:
          checkAll?.permissions?.find((y) => y?.permission === "UPDATE")
            ?.status === "ACTIVE"
            ? true
            : false,
        details:
          checkAll?.permissions?.find((y) => y?.permission === "VIEW_DETAIL")
            ?.status === "ACTIVE"
            ? true
            : false,
        assign:
          checkAll?.permissions?.find((y) => y?.permission === "ASSIGN")
            ?.status === "ACTIVE"
            ? true
            : false,
        sync:
          checkAll?.permissions?.find((y) => y?.permission === "SYNC")
            ?.status === "ACTIVE"
            ? true
            : false,
        import:
          checkAll?.permissions?.find((y) => y?.permission === "IMPORT")
            ?.status === "ACTIVE"
            ? true
            : false,
        export:
          checkAll?.permissions?.find((y) => y?.permission === "EXPORT")
            ?.status === "ACTIVE"
            ? true
            : false,
      };

      setPageMenu(fakePageMenu);
    }
  }, [state]);

  useEffect(() => {
    pageMenu.list && getData();
  }, [pageMenu, filter, refresh]);

  const handleKeyUp = (event) => {
    if (event.keyCode === 13) {
      form.submit();
    }
  };

  const Row = ({ children, ...props }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: props["data-row-key"],
    });
    const style = {
      ...props.style,
      transform: CSS.Transform.toString(
        transform && {
          ...transform,
          scaleY: 1,
        }
      ),
      transition,
      ...(isDragging
        ? {
            position: "relative",
            zIndex: 99,
          }
        : {}),
    };
    return (
      <tr {...props} ref={setNodeRef} style={style} {...attributes}>
        {React.Children.map(children, (child) => {
          if (child.key === "sort") {
            return React.cloneElement(child, {
              children: (
                <MenuOutlined
                  ref={setActivatorNodeRef}
                  className="haveDrag"
                  style={{
                    touchAction: "none",
                    cursor: "move",
                  }}
                  {...listeners}
                />
              ),
            });
          }
          return child;
        })}
      </tr>
    );
  };

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setItems((previous) => {
        const activeIndex = previous.findIndex((i) => i.key === active.id);
        const overIndex = previous.findIndex((i) => i.key === over?.id);
        return arrayMove(previous, activeIndex, overIndex);
      });
    }
  };

  const handleDeleteImageCreate = (image) => {
    let images = [...imagesCreate];
    images = images.filter((x) => x !== image);
    setImagesCreate(images);
  };

  const handleDeleteImageUpdate = (image) => {
    let images = [...imagesUpdate];
    images = images.filter((x) => x !== image);
    setImagesUpdate(images);
  };
  return (
    pageMenu.list && (
      <>
        {" "}
        <OverlaySpinner text="Vui lòng đợi ..." open={loading} />
        <div
          className="clients"
          onKeyDown={handleKeyUp}
          tabIndex="0"
          style={{ outline: "none" }}
        >
          <Modal
            title=""
            open={openModalCreate}
            onCancel={(e) => {
              setOpenModalCreate(false);
              formCreate.resetFields();
              setImagesCreate([]);
            }}
            width={1080}
            className="newZoom"
            footer={null}
            centered
          >
            <div style={{ minHeight: "540px" }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  borderBottom: "1px solid rgb(117, 218, 239)",
                  fontSize: "14px",
                  marginTop: "16px",
                  position: "relative",
                }}
              >
                <div
                  key={1}
                  style={{
                    transform: "translateY(0.5px)",
                    height: "32px",
                    border: "solid 1px rgb(117, 218, 239)",
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0 4px",
                    borderBottom: "solid 1px #fff",
                  }}
                >
                  <div style={{ padding: "0 8px" }}>Tạo mới</div>
                </div>

                {pageMenu.create && (
                  <div
                    className="checkCustomer__content__submit"
                    style={{ marginTop: "0", position: "absolute", right: "0" }}
                  >
                    <button
                      onClick={() => formCreate.submit()}
                      style={{ height: "30px", width: "120px" }}
                    >
                      Tạo mới
                    </button>
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "6px",
                }}
              >
                <span
                  style={{
                    background: "#fff",
                    width: "140px",
                    fontWeight: "bold",
                  }}
                >
                  Thông tin chung
                </span>
                <div
                  style={{
                    border: "solid 1px rgb(212,212,212)",
                    width: "100%",
                  }}
                ></div>
              </div>
              <Form
                layout="vertical"
                form={formCreate}
                onFinish={handleFinishFormCreate}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Form.Item
                    label="Họ tên"
                    name="name"
                    style={{ width: "calc(50% - 8px)" }}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>
                  <Form.Item
                    label="Email đăng ký Exness"
                    name="email"
                    style={{ width: "calc(50% - 8px)" }}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>
                </div>
                <div
                  style={{
                    marginTop: "-10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Form.Item
                    label="Tên Zalo"
                    name="zalo_name"
                    style={{ width: "calc(50% - 8px)" }}
                  >
                    <Input placeholder="Tên Zalo" />
                  </Form.Item>
                  <Form.Item
                    label="Username telegram"
                    name="telegram_username"
                    style={{ width: "calc(50% - 8px)" }}
                  >
                    <Input placeholder="Username telegram" />
                  </Form.Item>
                </div>
                <div
                  style={{
                    marginTop: "-10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Form.Item
                    label="Số điện thoại"
                    name="phone"
                    style={{ width: "calc(25% - (48px/4))" }}
                  >
                    <Input placeholder="Số điện thoại" />
                  </Form.Item>
                  <Form.Item
                    label="Số điện thoại Zalo"
                    name="zalo_phone"
                    style={{ width: "calc(25% - (48px/4))" }}
                  >
                    <Input placeholder="Số điện thoại Zalo" />
                  </Form.Item>

                  <Form.Item
                    label="Giới tính"
                    name="gender"
                    style={{ width: "calc(25% - (48px/4))" }}
                  >
                    <Select
                      allowClear
                      options={[
                        { label: "Nam", value: "MALE" },
                        { label: "Nữ", value: "FEMALE" },
                      ]}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Năm sinh"
                    name="dob"
                    style={{ width: "calc(25% - (48px/4))" }}
                  >
                    <Input placeholder="Năm sinh" />
                  </Form.Item>
                </div>
                <Form.Item
                  label="Ghi chú"
                  name="supporter_note"
                  style={{ width: "100%", marginTop: "-10px" }}
                >
                  <Input placeholder="Ghi chú" />
                </Form.Item>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: "-12px",
                  }}
                >
                  <span
                    style={{
                      background: "#fff",
                      width: "160px",
                      fontWeight: "bold",
                    }}
                  >
                    Thông tin giao dịch
                  </span>
                  <div
                    style={{
                      border: "solid 1px rgb(212,212,212)",
                      width: "100%",
                    }}
                  ></div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Form.Item
                    label="ID giao dịch"
                    name="trade_account_for_contest"
                    style={{ width: "calc(25% - 12px" }}
                  >
                    <Input placeholder="ID tài khoản đăng kí thi" />
                  </Form.Item>
                  <Form.Item
                    label="Mật khẩu"
                    name="passview"
                    style={{ width: "calc(25% - 12px" }}
                  >
                    <Input placeholder="Mật khẩu" />
                  </Form.Item>
                  <Form.Item
                    label="Nền tảng giao dịch"
                    name="trade_app"
                    style={{ width: "calc(25% - 12px" }}
                  >
                    <Input placeholder="Nền tảng giao dịch" />
                  </Form.Item>
                  <Form.Item
                    label="Máy chủ giao dịch"
                    name="trade_server"
                    style={{ width: "calc(25% - 12px" }}
                  >
                    <Input placeholder="Máy chủ giao dịch" />
                  </Form.Item>
                </div>
                <div style={{ marginTop: "-16px" }}>Hình ảnh:</div>
                <div style={{ display: "flex" }}>
                  {imagesCreate.length > 0 &&
                    imagesCreate.map((x) => (
                      <div
                        style={{
                          width: "80px",
                          height: "80px",
                          border: "1px dotted #000",
                          display: "flex",
                          borderRadius: "12px",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "8px",
                        }}
                        className="imageGolden"
                      >
                        <div
                          className="deleteImageGolden"
                          onClick={() => handleDeleteImageCreate(x)}
                        >
                          <RiDeleteBin2Line size={22} />
                        </div>
                        <img
                          src={`${API_URL_BOOK}${x}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    ))}
                  <div>
                    <label
                      htmlFor="imageFileCreate"
                      style={{
                        width: "80px",
                        height: "80px",
                        border: "1px dotted #000",
                        display: "flex",
                        borderRadius: "12px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CiCirclePlus size={32} />
                    </label>
                    <input
                      type="file"
                      id="imageFileCreate"
                      label="Choose Image"
                      onChange={uploadFileHandlerCreate}
                      style={{ display: "none" }}
                    ></input>
                  </div>
                </div>
                <div>
                  <p
                    style={{ fontSize: "14px", marginBottom: "4px" }}
                    onClick={() => {
                      console.log("update new");
                    }}
                  >
                    Nội dung:
                  </p>
                  <Editor
                    onInit={(evt, editor) => (editorRef.current = editor)}
                    initialValue=""
                    apiKey="j3su5e7yfilsrpsbi8u6m0wjdipy9i5lp9wopyvoqm1b1k6v"
                    init={{
                      height: 300,
                      menubar: true,
                      plugins:
                        "print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons",
                      menubar: "file edit view insert format tools table help",
                      toolbar:
                        "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl",

                      content_style:
                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                    }}
                  />
                </div>
              </Form>
            </div>
          </Modal>

          <Modal
            title=""
            open={openModal}
            onCancel={(e) => {
              setOpenModal(false);
              setDataDetails(undefined);
              setImagesUpdate([]);
            }}
            width={1080}
            footer={null}
            centered
          >
            <div style={{ minHeight: "540px" }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  borderBottom: "1px solid rgb(117, 218, 239)",
                  fontSize: "14px",
                  marginTop: "16px",
                  position: "relative",
                }}
              >
                <div
                  key={1}
                  style={{
                    transform: "translateY(0.5px)",
                    height: "32px",
                    border: "solid 1px rgb(117, 218, 239)",
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0 4px",
                    borderBottom: "solid 1px #fff",
                  }}
                >
                  <div style={{ padding: "0 8px" }}>Thông tin</div>
                </div>

                {pageMenu.update && (
                  <div
                    className="checkCustomer__content__submit"
                    style={{ marginTop: "0", position: "absolute", right: "0" }}
                  >
                    <button
                      onClick={() => formUpdate.submit()}
                      style={{ height: "30px", width: "120px" }}
                    >
                      Lưu
                    </button>
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "6px",
                }}
              >
                <span
                  style={{
                    background: "#fff",
                    width: "140px",
                    fontWeight: "bold",
                  }}
                >
                  Thông tin chung
                </span>
                <div
                  style={{
                    border: "solid 1px rgb(212,212,212)",
                    width: "100%",
                  }}
                ></div>
              </div>
              <Form
                layout="vertical"
                form={formUpdate}
                onFinish={handleFinishFormUpdate}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Form.Item
                    label="Họ tên"
                    name="name"
                    style={{ width: "calc(50% - 8px)" }}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>
                  <Form.Item
                    label="Email đăng ký Exness"
                    name="email"
                    style={{ width: "calc(50% - 8px)" }}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>
                </div>
                <div
                  style={{
                    marginTop: "-16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Form.Item
                    label="Tên Zalo"
                    name="zalo_name"
                    style={{ width: "calc(50% - 8px)" }}
                  >
                    <Input placeholder="Tên Zalo" />
                  </Form.Item>
                  <Form.Item
                    label="Username telegram"
                    name="telegram_username"
                    style={{ width: "calc(50% - 8px)" }}
                  >
                    <Input placeholder="Username telegram" />
                  </Form.Item>
                </div>
                <div
                  style={{
                    marginTop: "-16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Form.Item
                    label="Số điện thoại"
                    name="phone"
                    style={{ width: "calc(25% - (48px/4))" }}
                  >
                    <Input placeholder="Số điện thoại" />
                  </Form.Item>
                  <Form.Item
                    label="Số điện thoại Zalo"
                    name="zalo_phone"
                    style={{ width: "calc(25% - (48px/4))" }}
                  >
                    <Input placeholder="Số điện thoại Zalo" />
                  </Form.Item>

                  <Form.Item
                    label="Giới tính"
                    name="gender"
                    style={{ width: "calc(25% - (48px/4))" }}
                  >
                    <Select
                      allowClear
                      options={[
                        { label: "Nam", value: "MALE" },
                        { label: "Nữ", value: "FEMALE" },
                      ]}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Năm sinh"
                    name="dob"
                    style={{ width: "calc(25% - (48px/4))" }}
                  >
                    <Input placeholder="Năm sinh" />
                  </Form.Item>
                </div>
                <Form.Item
                  label="Ghi chú"
                  name="supporter_note"
                  style={{ width: "100%", marginTop: "-16px" }}
                >
                  <Input placeholder="Ghi chú" />
                </Form.Item>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: "-16px",
                  }}
                >
                  <span
                    style={{
                      background: "#fff",
                      width: "160px",
                      fontWeight: "bold",
                    }}
                  >
                    Thông tin giao dịch
                  </span>
                  <div
                    style={{
                      border: "solid 1px rgb(212,212,212)",
                      width: "100%",
                    }}
                  ></div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Form.Item
                    label="ID giao dịch"
                    name="trade_account_for_contest"
                    style={{ width: "calc(25% - 12px" }}
                  >
                    <Input placeholder="ID tài khoản đăng kí thi" />
                  </Form.Item>
                  <Form.Item
                    label="Mật khẩu"
                    name="passview"
                    style={{ width: "calc(25% - 12px" }}
                  >
                    <Input placeholder="Mật khẩu" />
                  </Form.Item>
                  <Form.Item
                    label="Nền tảng giao dịch"
                    name="trade_app"
                    style={{ width: "calc(25% - 12px" }}
                  >
                    <Input placeholder="Nền tảng giao dịch" />
                  </Form.Item>
                  <Form.Item
                    label="Máy chủ giao dịch"
                    name="trade_server"
                    style={{ width: "calc(25% - 12px" }}
                  >
                    <Input placeholder="Máy chủ giao dịch" />
                  </Form.Item>
                </div>
                <div style={{ marginTop: "-16px" }}>Hình ảnh</div>
                <div style={{ display: "flex" }}>
                  {imagesUpdate.length > 0 &&
                    imagesUpdate.map((x) => (
                      <div
                        style={{
                          width: "80px",
                          height: "80px",
                          border: "1px dotted #000",
                          display: "flex",
                          borderRadius: "12px",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "8px",
                        }}
                        className="imageGolden"
                      >
                        <div
                          className="deleteImageGolden"
                          onClick={() => handleDeleteImageUpdate(x)}
                        >
                          <RiDeleteBin2Line size={22} />
                        </div>
                        <img
                          src={`${API_URL_BOOK}${x}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    ))}
                  <div>
                    <label
                      htmlFor="imageFileUpdate"
                      style={{
                        width: "80px",
                        height: "80px",
                        border: "1px dotted #000",
                        display: "flex",
                        borderRadius: "12px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CiCirclePlus size={32} />
                    </label>
                    <input
                      type="file"
                      id="imageFileUpdate"
                      label="Choose Image"
                      onChange={uploadFileHandlerUpdate}
                      style={{ display: "none" }}
                    ></input>
                  </div>
                </div>
                <div>
                  <p
                    style={{ fontSize: "14px", marginBottom: "4px" }}
                    onClick={() => {
                      console.log("update new");
                    }}
                  >
                    Nội dung:
                  </p>
                  <Editor
                    onInit={(evt, editor) => (editorRef.current = editor)}
                    initialValue={dataDes}
                    apiKey="j3su5e7yfilsrpsbi8u6m0wjdipy9i5lp9wopyvoqm1b1k6v"
                    init={{
                      height: 300,
                      menubar: true,
                      plugins:
                        "print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons",
                      menubar: "file edit view insert format tools table help",
                      toolbar:
                        "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl",

                      content_style:
                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                    }}
                  />
                </div>
              </Form>
            </div>
          </Modal>
          <Form
            className="clients__search"
            layout="vertical"
            form={form}
            onFinish={handleFinishForm}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Form.Item
                  label="Tìm kiếm"
                  name="q"
                  style={{ width: "calc(100% - 608px)" }}
                >
                  <Input placeholder="Nhập họ tên, email, sđt, v..v.." />
                </Form.Item>
                <Form.Item
                  label="Trạng thái"
                  name="status"
                  style={{ width: "calc(220px)" }}
                >
                  <Select
                    allowClear
                    options={[
                      { label: "Kich hoạt", value: "ACTIVE" },
                      { label: "Tạm ẩn", value: "INACTIVE" },
                    ]}
                    placeholder="Tất cả"
                  />
                </Form.Item>
                <Button
                  className="clients__search__button"
                  onClick={() => form.submit()}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <AiOutlineSearch size={20} />
                  &nbsp;Tìm kiếm
                </Button>
                <Button
                  className="clients__search__button"
                  onClick={() => {
                    form.resetFields();

                    setFilter({
                      q: undefined,
                      status: undefined,
                      page: 1,
                      limit: 10,
                    });
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <AiOutlineReload size={20} />
                  &nbsp;Refresh
                </Button>

                {pageMenu.create && (
                  <Button
                    className="userSystem__search__button"
                    onClick={() => setOpenModalCreate(true)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FiPlusCircle size={20} />
                    &nbsp;Tạo mới
                  </Button>
                )}
              </div>
            </div>
          </Form>

          {/* <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
          <SortableContext
            items={dataSource.map((i) => i?.position)}
            strategy={verticalListSortingStrategy}
          >
            <Table
              bordered
              components={{
                body: {
                  row: Row,
                },
              }}
              className="custom__column1 newpadding "
              rowKey="position"
              columns={columnsData(
                {
                  state,
                  handleOpenModal,
                  handleSort,
                  filter,
                },
                pageMenu
              )}
              dataSource={dataSource}
              pagination={false}
            />
          </SortableContext>
        </DndContext> */}
          <Form
            className="formCreate__search--mobile"
            layout="vertical"
            form={form}
            onFinish={handleFinishForm}
          >
            <Form.Item
              label="Tìm kiếm"
              name="q"
              style={{ width: "calc(100% - 236px)" }}
            >
              <Input placeholder="Nhập họ tên, email, sđt, v..v.." />
            </Form.Item>
            <Form.Item
              label="Trạng thái"
              name="status"
              style={{ width: "calc(120px)" }}
            >
              <Select
                allowClear
                options={[
                  { label: "Kich hoạt", value: "ACTIVE" },
                  { label: "Tạm ẩn", value: "INACTIVE" },
                ]}
                placeholder="Tất cả"
              />
            </Form.Item>
            <Button
              className="formCreate__search__button"
              onClick={() => form.submit()}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AiOutlineSearch size={14} />
              &nbsp;Tìm kiếm
            </Button>
          </Form>
          <div
            className="formCreate__search--mobile"
            style={{
              width: "100%",
              justifyContent: "right",
              marginBottom: "8px",
              marginTop: "-12px",
            }}
          >
            {pageMenu.create && (
              <Button
                className="formCreate__search__button"
                onClick={() => setOpenModal(true)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FiPlusCircle size={14} />
                &nbsp;Tạo mới
              </Button>
            )}
          </div>
          <Table
            bordered
            className="custom__column1 newpadding hideMobile"
            scroll={{ x: 1000 }}
            rowKey="_id"
            columns={columnsData(
              {
                state,
                handleOpenModal,
                handleSort,
                handleChangeStatus,
                filter,
              },
              pageMenu
            )}
            dataSource={dataSource}
            pagination={false}
          />
          <Table
            bordered
            className="custom__column1 newpadding unhideMobile"
            scroll={{ x: 1000 }}
            rowKey="_id"
            columns={columnsDataMobile(
              {
                state,
                handleOpenModal,
                handleSort,
                handleChangeStatus,
                filter,
              },
              pageMenu
            )}
            dataSource={dataSource}
            pagination={false}
          />
          <PanigationAntStyled
            style={{ padding: "0 0 24px 0" }}
            current={filter.page}
            pageSize={filter.limit}
            showSizeChanger
            onChange={onChangePaging}
            showTotal={() => `Tổng ${total}`}
            total={total}
          />
          <div className="gapMobile"></div>
        </div>
      </>
    )
  );
};

export default GoldenBooks;
